import DSBox from "views/system-design/DSBox";
import DSInput from "views/system-design/DSInput";
import DSInputLabel from "views/system-design/DSInputLabel";

interface LogFiltersProps {
  fromVersion: number | null;
  setFromVersion: (version: number | null) => void;
  toVersion: number | null;
  setToVersion: (version: number | null) => void;
  specificVersion: number | null;
  setSpecificVersion: (version: number | null) => void;
}

const parseNumberInput = (value: string): number | null => {
  if (!value.trim()) return null;
  const parsed = parseFloat(value);
  return isNaN(parsed) ? null : parsed;
};

interface VersionInputProps {
  label: string;
  value: number | null;
  onChange: (version: number | null) => void;
  disabled: boolean;
  placeholder: string;
}

const VersionInput = ({
  label,
  value,
  onChange,
  disabled,
  placeholder,
}: VersionInputProps) => (
  <>
    <DSInputLabel>{label}</DSInputLabel>
    <DSInput
      disabled={disabled}
      type="number"
      value={value ?? ""}
      onChange={(e) => onChange(parseNumberInput(e.target.value))}
      placeholder={placeholder}
    />
  </>
);

const LogFilters = ({
  setFromVersion,
  setToVersion,
  setSpecificVersion,
  specificVersion,
  fromVersion,
  toVersion,
}: LogFiltersProps) => {
  const hasRange = fromVersion != null || toVersion != null;

  return (
    <DSBox sx={{ display: "flex", gap: 2, alignItems: "center" }}>
      <VersionInput
        label="Specific Version:"
        value={specificVersion}
        onChange={setSpecificVersion}
        disabled={hasRange}
        placeholder="version (e.g., 600.1)"
      />
      <VersionInput
        label="From Version:"
        value={fromVersion}
        onChange={setFromVersion}
        disabled={specificVersion != null}
        placeholder="Min version"
      />
      <VersionInput
        label="To Version:"
        value={toVersion}
        onChange={setToVersion}
        disabled={specificVersion != null}
        placeholder="Max version"
      />
    </DSBox>
  );
};
export default LogFilters;
